module.exports = __webpack_public_path__ + "static/khadaslogo-5d4011b983f5c75e646fd727cdfa756e.png";